export default __webpack_public_path__ + "static/media/novelist.b0d501d8.jpg";